import { IAjaxMapRoundaboutResponse } from 'shared/common/repository-manually-added/monolith-python/ajax/map/roundabout';
import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectSimilarObjectsApiResult(state: TApplicationState): IAjaxMapRoundaboutResponse | null {
  return state.similarObjects.data;
}
